var map = {
	"./Aftersalesmanagement.svg": "bb43",
	"./Barcodemanagement.svg": "316a",
	"./Billingmanagement.svg": "51ef",
	"./CSP.svg": "0368",
	"./Capabilitymanagement.svg": "014f",
	"./Deliveryplan.svg": "7fc4",
	"./ExpressPlatform.svg": "f4c0",
	"./Inventorycenter.svg": "d84d",
	"./Inventorymanagement.svg": "2111",
	"./Login-Icon.svg": "7541",
	"./Masterclassroom.svg": "c0d2",
	"./Ordermanagement.svg": "b871",
	"./Outboundmanagement.svg": "bbbb",
	"./PAD.svg": "ea22",
	"./PADadministration.svg": "bc2a",
	"./Policyconfiguration.svg": "78e6",
	"./Signinmanagement.svg": "d8cc",
	"./TMS.svg": "7c67",
	"./Warehousing.svg": "a871",
	"./app-client.svg": "01c0",
	"./bar code.svg": "c683",
	"./bms-menu.svg": "b1c8",
	"./csp-menu.svg": "e476",
	"./fpl-menu.svg": "1ec5",
	"./icon6.svg": "3446",
	"./lightning.svg": "4ed0",
	"./logo-large.svg": "4211",
	"./ods-menu.svg": "6920",
	"./ods.svg": "661c",
	"./pms-menu.svg": "a66e",
	"./prompt-dialog.svg": "6830",
	"./resourcemanagement.svg": "0e1b",
	"./statisticalanalysis.svg": "a810",
	"./stock.svg": "2f62",
	"./strategy.svg": "e279",
	"./taskmanagement.svg": "a1a1",
	"./tms-menu.svg": "08cc",
	"./transportationManagement.svg": "e24c",
	"./truck-fast.svg": "0dd0",
	"./warehouse.svg": "e53c",
	"./warehousingmanagement.svg": "5cf1",
	"./web-client.svg": "0b2c",
	"./wechat.svg": "95d6",
	"./wms-menu.svg": "3462",
	"./wms.svg": "abbf",
	"./workbench.svg": "3584"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";